import React from 'react';
import { EditorPrebuiltModule } from '@dev/template-editor';
import { useTranslation } from 'react-i18next';
import { GalleryTwoColumnsPreview } from './preview';

export const useGalleryTwoColumns = (): EditorPrebuiltModule => {
    const { t } = useTranslation();
    return {
        id: 'gallery-two-columns',
        title: t('gallerytwocolumns'),
        icon: <GalleryTwoColumnsPreview />,
        data: {
            name: 'editor/twocolumnsfiftyfiftyblock-v1',
            attributes: {},
            innerBlocks: [
                [
                    {
                        name: 'editor/imageblock-v1',
                        attributes: {},
                    },
                ],
                [
                    {
                        name: 'editor/imageblock-v1',
                        attributes: {},
                    },
                ],
            ],
        },
    };
};
